/**
 * 
 * Left.js
 * 
 */

import React, { Component } from 'react'
import { Container } from 'react-bootstrap';

 

 export default class Left extends Component {

    static displayName = Left.name;


     render() {


         return (

             <Container style={{ backgroundColor: '', paddingTop: '' }}>
                 
                <span style={{ backgroundColor: '', padding: '30px', paddingLeft: '20px', paddingTop: '0px', fontSize: '45px' }}>
                    About Us
                </span>

                <p style={{ padding: '20px', paddingBottom: '0px', fontSize: '20px', fontWeight: 'lighter', textAlign: 'left' }}>
                    Smile is a software development company that is building its first product: The Smile app! We created Smile as a unique solution out of the frustration and challenges we faced. Waiting for a solution was not an option so we teamed up and set to work. We are working on the Smile app and are close to launching our alpha version!
                </p>

             </Container>


         )


     }


 }
 

 
